export enum ReferralSubmitInternalCodesEnum {
    PendingSubmission = 1,
    Submitted = 2
}